import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import Images from "assets/images"
import { profileEditRoute } from "client/parts/routes"
import {
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    Logo,
    FormGroup,
    Label,
    Input,
    Button,
} from "client/components"

import ChangePassword from "client/parts/auth/changePassword"

const Form = () => {
    const profile = useSelector((state: StoreType) => state.userProfile.profileView)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    return (
        <PageForm>
            <Row>
                <Col xs={12} md={3}>
                    <Logo logo={profile.logo || Images.noAvatar} />
                </Col>
                <Col xs={12} md={9}>
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>{lang.firstName}</Label>
                                <Input type="text" value={profile.firstName} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.lastName}</Label>
                                <Input type="text" value={profile.lastName} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.login}</Label>
                                <Input type="text" value={profile.login} readOnly />
                            </FormGroup>
                            <FormGroup>
                                <Label>{lang.email}</Label>
                                <Input type="text" value={profile.email} readOnly />
                            </FormGroup>
                        </Col>
                        <Col xs={12}>
                            <Button row onClick={() => dispatch(addModal({ url: profileEditRoute }))}>
                                {lang.edit}
                            </Button>
                            <Button
                                row
                                onClick={() => {
                                    dispatch(addModal({
                                        key: "changePassword",
                                        content: <ChangePassword />,
                                    }))
                                }}
                            >
                                {lang.changePassword}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </PageForm>
    )
}
export default Form
